
import {translate} from '@elements/translations';
import {defineComponent, defineEmits} from 'vue';
import { storeToRefs } from 'pinia'
import { useTicketStore } from '../../stores/TicketStore';
import { useActivityStore } from '../../stores/ActivityStore';

export default defineComponent({
    name: 'ModalHeader',
    props: {
        type: {
            type: String,
            required: false,
            default: "ticket"
        },
    },
    emits: ['closeModal'],
    setup(props, {emit}) {
        const isActivity = props.type === "activity";
        const ticketStore = isActivity ? useActivityStore() : useTicketStore();

        const { step } = storeToRefs(ticketStore);
        const { changeStep } = ticketStore;
        const isMobile = matchMedia('(max-width: 767px)').matches;

        const goBack = () => {
            if(step.value > 0) {
                changeStep(step.value - 1);
            } else {
                emit('closeModal', true);
            }
        };

        return {
            goBack,
            isMobile,
            translate
        };
    }
});
